export const queryKeys = {
  HOUSE: 'HOUSE',
  MONTH: 'MONTH',
  EMPLOYEE: 'EMPLOYEE'
};
